import { Injectable } from '@angular/core';
import { LoginUser } from '../models/database_models/login_user';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { RegisterUser } from '../models/database_models/register_user';
import { CompanyService } from './company.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from '../../../environments/environment';
import { NewPasswordUser } from '../models/database_models/newpassword_user';
import { Observable } from 'rxjs';
import { JwtHelperService } from '@auth0/angular-jwt';

@Injectable({
	providedIn: 'root'
})
export class AuthService {
	private API_URL: string = environment.API_URL + 'api/Auth/';
	private CAPTCHA: string = environment.API_URL + 'api/Captcha/ValidGoogleReCaptcha';

	private TOKEN_KEY = 'token';
	private COMPANY_KEY = 'COMPANYID';

	constructor(
		private httpClient: HttpClient,
		private router: Router,
		private companyService: CompanyService,
		private activatedRoute: ActivatedRoute,
		private snackBar: MatSnackBar,
		private jwtHelper: JwtHelperService
	) { }

	login(loginUser: LoginUser) {
		const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
		this.httpClient
			.post(this.API_URL + 'login', loginUser, { headers })
			.subscribe(
				(data: any) => {
					this.saveToken(data);
					const decoded = this.jwtHelper.decodeToken(data);
					this.saveUserSession(decoded);
					this.router.navigateByUrl('/home').then(() => location.reload());
				},
				error => {
					this.snackBar.open('Girilen E-Posta Adresi ve/veya Parola hatalı.', null, {
						duration: 3000,
						horizontalPosition: 'right'
					});
				}
			);
	}

	autoLogin(token: string) {
		const headers = new HttpHeaders({ 'Content-Type': 'application/json', token });

		this.httpClient
			.post<string>(this.API_URL + 'autologin', token, { headers })
			.subscribe(
				data => {
					this.saveToken(data);
					const decoded = this.jwtHelper.decodeToken(data);
					this.saveUserSession(decoded);
					this.router.navigateByUrl('/home').then(() => location.reload());
				},
				error => {
					this.router.navigateByUrl('login').then(() => {
						this.snackBar.open('Girilen E-Posta Adresi ve/veya Parola hatalı.', null, {
							duration: 3000,
							horizontalPosition: 'right'
						});
					});
				}
			);
	}

	register(registerUser: RegisterUser) {
		const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
		return this.httpClient.post(this.API_URL + 'register', registerUser, { headers }).subscribe();
	}

	forgotPassword(email: string): Observable<any> {
		const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
		return this.httpClient.get(this.API_URL + 'forgetpassword?userName=' + email, { headers });
	}

	changePassword(registerUser: NewPasswordUser): Observable<any> {
		const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
		return this.httpClient.post(this.API_URL + 'changePassword', registerUser, { headers });
	}

	saveToken(token: string) {
		localStorage.setItem(this.TOKEN_KEY, token);
	}

	saveUserSession(decodedToken: any) {
		localStorage.setItem(this.COMPANY_KEY, decodedToken.certserialnumber);
		localStorage.setItem('userRole', decodedToken.role);
		localStorage.setItem('loggedUser', 'true');
	}

	logOut() {
		localStorage.clear();
		this.router.navigateByUrl('/login').then(() => location.reload());
	}

	loggedIn(): boolean {
		const token = localStorage.getItem(this.TOKEN_KEY);
		return token != null && !this.jwtHelper.isTokenExpired(token);
	}

	get token(): string {
		return localStorage.getItem(this.TOKEN_KEY);
	}

	getCurrentUserId(): string {
		const decoded = this.jwtHelper.decodeToken(this.token);
		return decoded.role;
	}

	CheckCaptcha(captcha: string): boolean {
		if (captcha) {
			const recapthca = JSON.stringify({ response: captcha });
			this.httpClient
				.post(this.CAPTCHA + '?response=' + captcha, null)
				.subscribe(
					r => true,
					error => {
						this.snackBar.open('Lütfen sayfayı yenileyip tekrar deneyiniz', null, {
							duration: 3000,
							horizontalPosition: 'right'
						});
					}
				);
		}
		return false;
	}

	getIP(): Observable<any> {
		const headers = new HttpHeaders({
			'Content-Type': 'application/json',
			'Authorization': 'Bearer ' + localStorage.getItem('token')
		});
		return this.httpClient.get(this.API_URL + 'kullaniciipgetir', { headers });
	}
}
